import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class Spei extends PaymentMethod {
  readonly clabe: string
  readonly sentTo: string

  constructor(data: JSON) {
    super(data)
    this.clabe = data.clabe
    this.sentTo = data.sent_to
  }
}
